import { ScrollableContents } from '@!/Store/Common/components/ScrollableList'

/* 各画面に表示される横スクロール型の特集リスト */
export const ScrollableFeatureList = ({ title, pathname, contents, gtmClick }) => {
  const url = `/store/features/${pathname}`
  return <ScrollableContents contents={contents} sectionTitle={title} url={url} gtmClick={gtmClick} />
}
